<template>
  <c-modal v-if="site" class="edit-client" :title="title" size="sm" :show="show" @update:show="toggle">
    <set-client :site="site" :is-saving="isSaving" @selected="selectClient"/>
    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" @click="save">
          <c-spinner v-if="isSaving" color="success" size="sm" />
          <span v-else>Update client</span>
        </c-button>
        <c-button v-if="!isSaving" color="secondary" @click="toggle(false)">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import SetClient from '@/views/components/clients/set';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'EditSiteClient',
  components: {
    SetClient,
  },
  props: {
    show: Boolean,
    site: Object,
  },
  data() {
    return {
      error: null,
      clients: [],
      isLoading: true,
      isSaving: false,
      selectedOption: null,
      showCreate: false,
      clientId: null,
    };
  },
  computed: {
    title() {
      return 'Set client for site';
    },
  },
  watch: {
    show(v) {
      if (!v) {
        this.selectedOption = null;
        this.isSaving = false;
      }
    },
  },
  mounted() {
    this.clientId = this.site.clientId;
  },
  methods: {
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    selectClient(e) {
      this.selectedOption = e;
    },
    save() {
      if (!this.selectedOption) {
        return;
      }
      this.isSaving = true;
      this.error = null;
      const data = {
        // eslint-disable-next-line no-underscore-dangle
        siteId: this.site._id,
        clientId: this.selectedOption.value,
      };
      this.$http
        .post(buildEndpoint('site/client/update'), data)
        .then((response) => {
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Client updated',
            });
            // const newClient = this.clients.find((client) => client.value === this.selectedOption);
            this.$emit('updated', this.selectedOption);
            this.toggle(false);
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>
